import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { useContext, useEffect, useMemo, useState } from 'react';
import useFetch from '../hooks/useFetch';
import useMap from '../hooks/useMap';
import useWindowSize from '../hooks/useWindowSize';
import { SET_FILTERED_POSTS, SET_POSTS, store } from '../state/state';
import { latitudeSort } from './ExplorerMap';
import IconSprite from './IconSprite';
import Map from './Map';
import MapUI from './MapUI';
const url = `${window.mainSiteData.root}scenic-rim/v2/listings?`;
const RegionalMap = () => {
    const { height } = useWindowSize();
    const { ref, map, loaded: mapLoaded } = useMap();
    const [route, setRoute] = useState(null);
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const { filteredPosts = [] } = state;
    const visibleFilteredPosts = useMemo(() => {
        return latitudeSort(filteredPosts || []);
    }, [filteredPosts]);
    const filterParams = useMemo(() => ({
        nonce: window.mainSiteData.nonce,
        postType: 'accommodation,attraction,general_service,journey,information_service,food_and_drink,tour'
    }), []);
    // Fetch listings
    const { data, error } = useFetch(url + new URLSearchParams(filterParams), {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'X-WP-Nonce': window.mainSiteData.nonce
        }
    });
    // Update fetched listings in state
    useEffect(() => {
        if (!error && data) {
            dispatch({
                type: SET_POSTS,
                posts: data?.posts || []
            });
        }
    }, [data]);
    // Update filtered posts when posts are stored in state
    useEffect(() => {
        dispatch({
            type: SET_FILTERED_POSTS,
            ...state,
            filteredPosts: state.posts
        });
    }, [state.posts]);
    // Handle map data
    useEffect(() => {
        if (!visibleFilteredPosts.length)
            return;
        setRoute({
            path: 'places',
            meta: {
                title: 'Places to visit',
                variant: 'blue',
                homeCard: false,
                showFilters: true,
                layer: {
                    title: 'Title',
                    intro: 'Intro',
                    icon: 'mountain',
                    posts: visibleFilteredPosts
                },
            },
        });
    }, [visibleFilteredPosts, setRoute]);
    return (_jsxs(_Fragment, { children: [_jsx(IconSprite, {}), _jsx("section", { className: "relative", children: _jsxs("div", { className: "relative w-full bg-grey-100", style: { height: height + 'px' }, children: [_jsx(Map, { mapRef: ref, loaded: mapLoaded }), mapLoaded && route && _jsx(MapUI, { map: map, routes: [route] })] }) })] }));
};
export default RegionalMap;
